var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEventImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "25px",
    viewBox: "0 0 33 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEventImage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-other-event-details",
    transform: "translate(-171.000000, -962.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(10.000000, 892.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(78.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo-(2)",
    transform: "translate(83.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0599068,0.0117132867 L2.03799534,0.0117132867 C0.912529138,0.0117132867 0,0.924184149 0,2.04965035 L0,22.9388112 C0,24.0642191 0.912529138,24.97669 2.03799534,24.97669 L30.0599068,24.97669 C31.1854312,24.97669 32.0979604,24.0642191 32.0979604,22.9387529 L32.0979604,2.04965035 C32.0979604,0.924184149 31.1854895,0.0117132867 30.0599068,0.0117132867 Z M30.0599068,2.04965035 L30.0599068,16.8712121 L26.0435897,13.219697 C25.4399184,12.670979 24.5115967,12.6928904 23.9348485,13.2701632 L19.8700466,17.334324 L11.8553613,7.76101399 C11.2495338,7.03752914 10.1398601,7.03041958 9.52494172,7.74522145 L2.03799534,16.4463287 L2.03799534,2.04965035 L30.0599068,2.04965035 Z M21.3986597,7.3993007 C21.3986597,5.85145688 22.6529138,4.59708625 24.2007576,4.59708625 C25.7486597,4.59708625 27.002972,5.85145688 27.002972,7.3993007 C27.002972,8.94714452 25.7487179,10.2014569 24.2007576,10.2014569 C22.652972,10.2015152 21.3986597,8.94714452 21.3986597,7.3993007 Z",
    id: "icEventImage"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEventImage);
export default __webpack_public_path__ + "static/media/icEventImage.f8a61e645930e762f4c6f011ee1a0357.svg";
export { ForwardRef as ReactComponent };